module.exports = __webpack_public_path__ + "img/rating-glade-3Ddg-JB.svg";